"use client";

import { create } from "zustand";

const useCurrencyStore = create((set, get) => ({
  exchangeRates: null,
  currentCurrency: "AED",
  set,
  get,
}));

export default useCurrencyStore;
